import { useState, useCallback, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import OAuthService from "../../auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { Switch } from "@mui/material";
import IconComponent from "app/shared-components/IconComponent";
import { useMediaQuery, useTheme } from '@mui/material';
import { isIAMOnlyUser, getIAMPartnerIds } from "../utilities/iamTerritoryUtils";
const Showroom = () => {
    const theme = useTheme();
      const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const navigate = useNavigate();
  const isIAMOnly = isIAMOnlyUser();
  const [error, setError] = useState();
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [deleteDisable, setDeleteDisable] = useState(true);
  const perPage = 10;
  const [gridApi, setGridApi] = useState(null);
  const [columnDefs, setColumnDefs] = useState([
    { field: "id", enableRowGroup: true, headerName: "Showroom Id",minWidth:50 },
    { field: "name", enableRowGroup: true, headerName: "Showroom Name",minWidth:50 },
    {
      field: "parentCompanyNumber",
      enableRowGroup: true,
      headerName: "Partner Number",minWidth:50,
    },
    {
      field: "parentCompanyName",
      enableRowGroup: true,
      headerName: "Partner Name",minWidth:50
    },
    // { field: 'countryName', enableRowGroup: true, headerName: 'Country' },
    { field: "region", enableRowGroup: true,minWidth:50 ,},
    // { field: 'emailId', enableRowGroup: true, headerName: 'Email' },
    { field: "active", enableRowGroup: true, cellRenderer: IconComponent },
  ]);

  const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showrooms}`;

  const handlePurge = async () => {
    gridApi?.showLoadingOverlay();
    try {
      await Promise.all(
        selectedRows.map((row) => OAuthService.deleteData(url, row.id))
      );
      setSuccessMsg("Data deleted Successfully");
      setSnackState(true);
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
    gridRef.current?.api?.deselectAll();
    loadData();
  };

  const onBtExport = useCallback(() => {
    const params = {
      fileName: "Showrooms.xlsx",
      sheetName: "Showrooms",
    };
    gridRef.current.api.exportDataAsExcel(params);
  }, []);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const loadData = async () => {
    gridApi?.showLoadingOverlay();
    try {
      const list = await OAuthService.getList(url + `?sort=name,asc&size=1000`);
      const data = list.data;
      const showrooms = data?._embedded.showrooms;
      if (isIAMOnly) {
        const partnerIds = await getIAMPartnerIds();
        setRowData(
          showrooms.filter((item) =>
            partnerIds.includes(String(item.parentCompanyNumber))
          )
        );
      } else {
        setRowData(showrooms);
      }
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    } finally {
    gridApi?.hideOverlay();
  }
  };

  useEffect(() => {
    if (gridApi) {
      loadData();
    }
  }, [gridApi]);

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

const goToRoleEdit = useCallback(
  (data) => {
    if (data?.id !== undefined) {
      navigate("/editShowroom/" + data.id);
    }
  },
  [navigate],
);
  const onRowDoubleClicked = (params) => {
    if (isMobile) return; 
    goToRoleEdit(params?.data);
  };

  const onRowClicked = (params) => {
    if (!isMobile) return; 
    goToRoleEdit(params?.data);
  };
  useEffect(() => {
    if (selectedRows.length > 0) {
      setDeleteDisable(false);
    } else {
      setDeleteDisable(true);
    }
  }, [selectedRows]);

  return (
    <>
      <ListPageHeader
        componentName="Showroom"
        onBtExport={onBtExport}
        handlePurge={handlePurge}
        addPageLink={isIAMOnly ? undefined : "/addShowroom"}
        pageName="Showroom List"
        error={error}
        successMsg={successMsg}
        deleteDisable={deleteDisable}
        snackState={snackState}
        gridRef={gridRef}
      />
      <div className="h-full">
        <AgGridTable
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          onSelectionChanged={onSelectionChanged}
          onRowDoubleClicked={onRowDoubleClicked}
          onRowClicked={onRowClicked}
          gridRef={gridRef}
          rowData={rowData}
          paginationPageSize={perPage}
          cacheBlockSize={perPage}
          saveGridStateName={"showroomList"}
        />
      </div>
    </>
  );
};

export default Showroom;
